import React from "react";
import { Box, Typography, IconButton, Grid } from "@mui/material";
import PrivacyImg from "./../../assets/images/privacy.png";
import ProtectionImg from "./../../assets/images/protection.png";
import SecurityImg from "./../../assets/images/security.png";
import RightArrow from "./../../assets/images/arrow-right-primary.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Safety = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box pt={8} pb={2}>
      <Box sx={{ textAlign: "center" }}>
        <Typography
        className="safe-heading"
          mt={3}
          fontWeight="bold"
          sx={{
            fontSize: "max(2.5rem, 4vw)",
          }}
        >
          <Typography variant="span" >{t("safety-h1-sub-1")}</Typography>
          <Typography color={"color.magentaDark3"} variant="span" >
            {t("safety-h1-sub-2")}
          </Typography>
        </Typography>

        <Grid container spacing={2} mt={8}>
          <Grid item lg={4} md={6} xs={12}>
            <Box
              display="flex"
              flexDirection={"column"}
              justifyContent={"space-between"}
              alignItems={"center"}
              height={"100%"}
            >
              <Box>
                <Typography
                  textAlign={"left"}
                  fontSize={"1.4rem"}
                  fontWeight={"600"}
                  className="safe-sub-heading"

                >
                  {t("safety-privacy-h")}
                </Typography>
                <Typography
                  textAlign={"left"}
                  fontSize={"1.07rem"}
                  lineHeight={"1.35rem"}
                  mt={1}
                  className="safe-text"

                >
                  {t("safety-Privacy-p")}
                </Typography>
              </Box>
              <Box as="img" src={PrivacyImg} width="30%" mt={6} />
            </Box>
          </Grid>
          <Grid item lg={4} md={6} xs={12}>
            <Box
              display="flex"
              flexDirection={"column"}
              justifyContent={"space-between"}
              alignItems={"center"}
              height={"100%"}
            >
              <Box>
                <Typography
                  fontSize={"1.4rem"}
                  fontWeight={"600"}
                  textAlign={"left"}
                  className="safe-sub-heading"

                >
                  {t("safety-security-h")}
                </Typography>
                <Typography
                  textAlign={"left"}
                  fontSize={"1.07rem"}
                  lineHeight={"1.35rem"}
                  mt={1}
                  className="safe-text"

                >
                  {t("safety-security-p")}
                </Typography>
              </Box>

              <Box as="img" src={SecurityImg} width="30%" mt={6} />
            </Box>
          </Grid>
          <Grid item lg={4} md={6} xs={12}>
            <Box
              display="flex"
              flexDirection={"column"}
              justifyContent={"space-between"}
              alignItems={"center"}
              height={"100%"}
            >
              <Box>
                <Typography
                  fontSize={"1.4rem"}
                  fontWeight={"600"}
                  textAlign={"left"}
                  className="safe-sub-heading"

                >
                  {t("safety-protecttion-h")}
                </Typography>
                <Typography
                  textAlign={"left"}
                  fontSize={"1.07rem"}
                  lineHeight={"1.35rem"}
                  mt={1}
                  className="safe-text"

                >
                  {t("safety-protecttion-p")}
                </Typography>
              </Box>
              <Box as="img" src={ProtectionImg} width="20%" mt={4} />
            </Box>
          </Grid>
        </Grid>
        <Typography
          my={9}
          mt={10}
          fontWeight={700}
          fontSize={"1.35rem"}
          color="color.magentaMid2"
        >
          <Typography variant="span" pr={1} className="safe-text"
>
            {t("saferty-learn-more")}
          </Typography>

          <IconButton
            onClick={() => {
              navigate("/faq");
            }}
          >
            <img src={RightArrow} height={17} className="safe-arrow" />
          </IconButton>
        </Typography>
      </Box>
    </Box>
  );
};

export default Safety;
